module.exports = __webpack_public_path__ + "logo-white.png?0d55a23f46eca040c340515d76b22a8f";